<div class="footer">
    <div class="footer__content">
        <div class="footer__info">
            <ul class="footer__links">
                <li class="footer__item"><a class="footer__link" href="https://www.massmutual.com/terms-of-use" target="_blank">Terms of Use</a></li>
                <li class="footer__item"><a class="footer__link" href="https://www.massmutual.com/legal/privacy" target="_blank">Privacy</a></li>
            </ul>
            <p class="footer__copyright">© {{ date.getFullYear() }} Massachusetts Mutual Life Insurance Company
                Springfield, MA 01111-0001. All rights reserved.</p>
            <p class="footer__meta">MassMutual Convertible Term is a term life insurance policy (ICC18TFC) issued by
                Massachusetts Mutual Life Insurance Company (MassMutual), Springfield, MA 01111</p>
        </div>
        <div class="footer__logo">
            <img class="footer__logo-image" src="/img/logo/mm-gray.svg"/>
        </div>
    </div>
</div>
